export default {
	title: '齿轮库',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	noData: {
		title: '暂无齿轮数据',
		description: '当前没有找到相关的齿轮数据'
	},
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		name: '齿轮名称',
		type: '齿轮类型',
		module: '模数',
		teethNumber: '齿数',
		pressureAngle: '压力角',
		material: '材料',
		placeholder: {
			name: '请输入齿轮名称',
			type: '请输入齿轮类型',
			module: '请输入模数',
			teethNumber: '请输入齿数',
			pressureAngle: '请输入压力角',
			material: '请输入材料'
		}
	},
	table: {
		name: '齿轮名称',
		type: '齿轮类型',
		module: '模数',
		teethNumber: '齿数',
		pressureAngle: '压力角',
		material: '材料'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	}
}
